import isVisible from './isVisible';

/**
 *
 * @param element
 * @param callback
 */
const clickOutside = (element, callback) => {
  const outsideClickListener = event => {
    if (!element.contains(event.target) && isVisible(element)) {
      callback();
      // eslint-disable-next-line no-use-before-define
      removeClickListener();
    }
  };

  const removeClickListener = () => {
    document.removeEventListener('click', outsideClickListener);
  };

  document.addEventListener('click', outsideClickListener);
};

export default clickOutside;
